import { FC, useEffect, useState } from "react";
// Redux
import { useAppSelector } from "hooks/useStore";
import { selectQuiz } from "store/quiz/quizSelectors";
import IQuiz from "models/Quiz";

type Props = {
  value: number;
  width: number;
  percent: number;
  label: string;
  userAnswer: boolean;
}


const AnswerItem:FC<Props> = ({ width, percent, value, label, userAnswer }) => {
  const quiz:IQuiz = useAppSelector(selectQuiz);

  const [w, setW] = useState<number>(0);

  useEffect(() => {
    let interval:any = null;

    interval = setInterval(() => {
      setW(prev => {
        if (prev + (width / 100) > width) {
          clearInterval(interval);
          return width;
        } else return prev + (width / 100);
      })
    }, 10)

    return () => {
      clearInterval(interval);
      setW(0);
    };
    // eslint-disable-next-line
  }, [width])

  return (
    <div className="mt-1">
      <div style={{ color: userAnswer ? quiz.resultsPage.currentPlacingFontColor : quiz.resultsPage.placingFontColor }} className="
        relative w-full max-w-full overflow-hidden
        flex items-center justify-between p-2
        shadow-lg rounded-xl
        bg-gradient-to-b from-white to-gray-300 
      ">
        <div
          key={width}
          className="h-full absolute top-0 left-0 rounded-xl"
          style={{
            width: `${w}%`,
            background: userAnswer
              ? `linear-gradient(to right, ${quiz.resultsPage.currentPlacingGradientStart}, ${quiz.resultsPage.currentPlacingGradientEnd})`
              : `linear-gradient(to right, ${quiz.resultsPage.placingGradientStart}, ${quiz.resultsPage.placingGradientEnd})`
          }}
        />
        <h3 className="relative text-lg font-bold z-1">{label}</h3>
        <p className="relative text-xs font-bold z-1">{`${percent}%`}</p>
      </div>
    </div>
  );
}
 
export default AnswerItem;

